//=require aos/dist/aos.js

(function (app) {
    app.aos = () => {

        let items = document.querySelectorAll('[data-aos]');

        items.forEach((item) => {
            let top = item.getBoundingClientRect().top + window.pageYOffset;

            if (top < window.innerHeight) {
                item.classList.add('aos-init');
                setTimeout(() => {
                    item.classList.add('aos-animate');
                }, 100);
            }
        })

        // Slide the callouts downwards and add a modifier to fade and zoom the images

        document.addEventListener('aos:in:slide', ( {detail} ) => {
            var slideFigure = detail.querySelector('figure')
            var slideContent = detail.querySelector('.js-content');
    
            var delayDesktop = Number(detail.dataset.delayDesktop) || 200;
            var delayMobile = Number(detail.dataset.delayMobile) || 200;
            var delay = window.matchMedia('(max-width: 999px)').matches ? delayMobile : delayDesktop;
    
            $(slideFigure).slideDown(delay).promise().done(function() {
                addModifider(slideFigure, 'active');
    
                if (slideContent) {
                    addModifider(slideContent, 'active');
                }
            })
        });

        /**
         * Modifies ALL the classes of an HTML element
         *
         * @param {html element} element The HTML element to add the modifier to
         * @param {string} modifier The modifier class
         * @return {string} Adds new modifier strings to element
         */
    
        const addModifider = (element, modifier) => {
            const classList = element.classList;
            const modifiers = Array.from(classList).map(cssClass => `${cssClass}--${modifier}`);
            element.classList.add(...modifiers);
        }
        
        AOS.init({
            once: false,
            offset: 0,
        });
    }
})(window.Inchbald = window.Inchbald || {});
